import axios from 'axios';
import React, { useState, useRef, useReducer, useEffect } from 'react';
import { Link, useNavigate, Navigate } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import '../../assets/css/custom-media-queries.css';
import '../../assets/css/custom-style.css';
import Footer from '../../layout/Footer';
import { createNotification } from '../helpers/Notification';
import { getApiUrl } from '../helpers/Util';
import { setLoginUserData } from '../project/redux/projectAction';
import { useSelector, useDispatch } from 'react-redux';


const Login = (props) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isAuthenticated, setIsAuthenticated] = useState(false); // Not used
    const [loader, setLoader] = useState(false); // Not used
    const validator = useRef(new SimpleReactValidator());
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const loginUserData = useSelector(state => state.loginUserData);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handelOnChange = (event) => {
        if (event.target.name === 'email') {
            setEmail(event.target.value);
        } else if (event.target.name === 'password') {
            setPassword(event.target.value);
        }
    };

    const onKeyUp = (event) => {
        if (event.charCode === 13) {
            handelLogin();
        }
    };

    const handelLogin = () => {
        let loginUserDataClone = { ...loginUserData };

        if (localStorage.getItem('user-token') && localStorage.getItem('user-token') !== "") {
            createNotification("error", "An active session already exists in this browser. Please log out first.");
            const currentRole = localStorage.getItem('roleKey');
            navigate(currentRole === 'user' ? '/transport' : '/dashboard');
            return;
        }

        if (validator.current.allValid()) {
            const payload = { email, password };
            const headers = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            const URL = getApiUrl();
            setLoader(true);
            axios.post(`${URL}/login`, payload, headers)
                .then((response) => {
                    if (response.status === 200) {
                        let result = response.data;
                        setIsAuthenticated(true);
                        localStorage.setItem('user-info', JSON.stringify(response.data));
                        localStorage.setItem('userName', result.data.profile.name);
                        localStorage.setItem('user-token', result.data.token);
                        localStorage.setItem('userId', result.data.profile.id);
                        localStorage.setItem('profileImage', result.data.profile.profileImage);
                        localStorage.setItem('roleKey', result.data.profile.roleKey);
                        if (result.data.profile.roleKey === 'user') {
                            navigate('/transport');
                        } else {
                            navigate('/dashboard');
                        }
                        dispatch(setLoginUserData({ ...loginUserDataClone, userName: result.data.profile.name, profileImage: result.data.profile.profileImage, roleKey: result.data.profile.roleKey }));
                        setLoader(false);
                        if (props.updateRoleKey) {
                            props.updateRoleKey(result.data.profile.roleKey);
                        }
                    }
                })
                .catch((error) => {
                    console.log("error", error);
                    if (error.response && error.response.data) {
                        let errMsg = error.response.data.message || (error.response.data.error && error.response.data.error.message);

                        if (errMsg === "You are not authorized to login. Please contact support to activate your account.") {
                            // Keep errMsg as is
                        } else if (errMsg === "Invalid credentials" || error.response.status === 401) {
                            errMsg = "You have entered an incorrect email or password!";
                        }

                        if (errMsg) {
                            createNotification("error", errMsg);
                        } else {
                            createNotification("error", "You have entered an incorrect email or password!");
                        }
                    } else {
                        createNotification("error", "An error occurred during login. Please try again.");
                    }
                    setLoader(false);
                });
        } else {
            validator.current.showMessages();
            forceUpdate();
        }
    };

    useEffect(() => {
        let checks = 0;
        const interval = setInterval(() => {
            const logoutMessage = sessionStorage.getItem('logoutMessage');
            if (logoutMessage) {
                createNotification("error", logoutMessage, 8000);
                sessionStorage.removeItem('logoutMessage');
                clearInterval(interval);
            }
            checks++;
            if (checks >= 5) clearInterval(interval); // Check for 2.5 seconds max
        }, 500);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'user-token' && e.newValue && e.newValue !== "") {
                const currentRole = localStorage.getItem('roleKey');
                navigate(currentRole === 'user' ? '/transport' : '/dashboard');
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, [navigate]);

    if (localStorage.getItem('user-token') && localStorage.getItem('user-token') !== "") {
        const currentRole = localStorage.getItem('roleKey');
        return <Navigate to={currentRole === 'user' ? '/transport' : '/dashboard'} replace />;
    }

    return (
        <>
            <main className="user-account-page">
                <div className="container-fluid">
                    <section className="form-container">
                        <div className="row">
                            <div className="col-md-6 logo-col">
                                <div className="logo-content-frame">
                                    <h1 className="logo-frame">
                                        <span className="logo"></span>
                                    </h1>
                                    <h2 className="title">Welcome, User</h2>
                                    <label className="lbl">Login to continue the access</label>
                                </div>
                            </div>
                            <div className="col-md-6 form-col">
                                <div className="content-frame">
                                    <h2 className="title">Sign in to Next Level Decking</h2>
                                    <section className="form-frame login-form">
                                        <div className="form-group mb-3">
                                            <input type="text" name="email" placeholder="Email" className="form-control" value={email} onChange={handelOnChange} onKeyPress={onKeyUp} />
                                            {validator.current.message('email', email, 'required|email', { className: 'text-danger' })}
                                        </div>
                                        <div className="form-group mb-3">
                                            <input type="password" name="password" placeholder="Password" className="form-control" onChange={handelOnChange} value={password} onKeyPress={onKeyUp} />
                                            {validator.current.message('password', password, 'required', { className: 'text-danger' })}
                                        </div>
                                        <p className="lbl-forgot-pswd"> <Link to="/forgotpassword"> Forgot Password? </Link></p>
                                        <div className="btn-row">
                                            <input type="button" name="signIn" value="Sign In" className="btn-rnd-black btn-signIn" onClick={handelLogin} />
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </main>
            <Footer />
        </>
    );
};

export default Login;

